module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.f22f23c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Medium.woff
// module id = LOdd
// module chunks = 0